var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPytorch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 199.7 40.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f05732",
    d: "M102.7 12.2c-1.3-1-1.8 3.9-4.4 3.9-3 0-4-13-6.3-13-.7 0-.8-.4-7.9 21.3-2.9 9 4.4 15.8 11.8 15.8 4.6 0 12.3-3 12.3-12.6 0-7.1-3.5-13.9-5.5-15.4zm-6.9 23.1c-3.7 0-6.7-3.1-6.7-7s3-7 6.7-7 6.7 3.1 6.7 7c0 3.8-3 7-6.7 7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e529f",
    d: "M99.8 0C99.3 0 98 2.5 98 3.6c0 1.5 1 2 1.8 2s1.8-.5 1.8-2c-.1-1.1-1.4-3.6-1.8-3.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M0 39.5V14.9h11.5c5.3 0 8.3 3.6 8.3 7.9 0 4.3-3 7.9-8.3 7.9H5.2v8.8H0zm14.4-16.7c0-2.1-1.6-3.3-3.7-3.3H5.2v6.6h5.5c2.1 0 3.7-1.3 3.7-3.3zm20.8 16.7V29.4l-9.4-14.5h6l6.1 9.8 6.1-9.8h5.9l-9.4 14.5v10.1h-5.3zm28.1 0v-20h-7.2v-4.6h19.6v4.6h-7.2v20h-5.2zm68.1 0l-4.8-8.7h-3.8v8.7h-5.2V14.9H129c5.1 0 8.3 3.4 8.3 7.9 0 4.3-2.8 6.7-5.4 7.3l5.6 9.4h-6.1zm.5-16.7c0-2-1.6-3.3-3.7-3.3h-5.5v6.6h5.5c2.1 0 3.7-1.2 3.7-3.3zm13.7 4.4c0-7.6 5.7-12.7 13.1-12.7 5.4 0 8.5 2.9 10.3 6l-4.5 2.2c-1-2-3.2-3.6-5.8-3.6-4.5 0-7.7 3.4-7.7 8.1 0 4.6 3.2 8.1 7.7 8.1 2.5 0 4.7-1.6 5.8-3.6l4.5 2.2c-1.7 3.1-4.9 6-10.3 6-7.4 0-13.1-5.2-13.1-12.7zm48.9 12.3V29.1h-11.6v10.4h-5.2V14.9h5.2v9.7h11.6v-9.7h5.3v24.6h-5.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPytorch);
export default __webpack_public_path__ + "static/media/pytorch.10ab8c6812b14da27c5321defe05a227.svg";
export { ForwardRef as ReactComponent };